import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BraveMoveThemeProvider } from '@bravemove/design-tokens/react';
import { I18nProvider } from '@bravemove/i18n/react';
import { ToastProvider, VerifiedTickProvider, resolveInitialPalette } from '@bravemove/ui-web';
import { App } from './App.tsx';
import { i18nPromise } from './i18n/index.ts';
import { installDevRtlToggle } from './i18n/devRtlToggle.ts';
import './styles/index.css';

// F09 v2 (§13) — every blue tick in the admin app is inert: no explainer link.
const adminTickExplainerHref = (): null => null;

const container = document.getElementById('root');
if (!container) throw new Error('Root element #root not found in index.html');

void i18nPromise.then((i18n) => {
  createRoot(container).render(
    <StrictMode>
      <BraveMoveThemeProvider initial={resolveInitialPalette('slate_light')}>
        <I18nProvider i18n={i18n}>
          <VerifiedTickProvider explainerHref={adminTickExplainerHref}>
            <ToastProvider>
              <App />
            </ToastProvider>
          </VerifiedTickProvider>
        </I18nProvider>
      </BraveMoveThemeProvider>
    </StrictMode>,
  );
  installDevRtlToggle();
});
